<template>
<div>
<v-autocomplete clearable :cache-items="true" maxlength="100" class="carihesapsearch" :disabled="engel" :label="etiket" height="32px" hide-details append-outer-icon="send" @click:append-outer="goDetailPage" :rules="rule" id="cariComp" @keyup.delete="deleteCariComp()" @click="selectCariComp()" :color="renk" :loading="loading" :autofocus="autofocuss" @blur="focuslost(Carihesap)" v-on="WatchStarter" :items="statecari" item-text="autoText" item-value="id" v-model="Carihesap" :name="Math.random()" :search-input.sync="searchcari" >
        <template v-slot:prepend>
        <v-icon color="info" @click="openSearhDialog()">search</v-icon>
      </template>
  
  <template v-slot:selection="data">
        <span class="teksatir">
            {{data.item.id}} -
        </span>
        <span class="teksatir" v-if="data.item.unvan2 && data.item.unvan2.length > 0 &&  1 > data.item.unvan1.length">
            {{data.item.unvan2}}
        </span>
        <span class="teksatir" v-if="data.item.unvan1 && data.item.unvan1.length > 0">
            {{data.item.unvan1 }}
        </span>
    </template>
    <template v-slot:item="data">
        <v-layout row wrap pa-1>
            <v-flex xs10 sm10 md4>
                <v-layout row wrap>
                    <v-flex xs10 sm10 md12>
                        <span class="subheading font-weight-medium"> {{ $t('Code') }}  </span>
                    </v-flex>
                    <v-flex xs10 sm10 md12>
                        <span class="body-1" v-html="data.item.id">
                        </span>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs10 sm10 md5>
                <v-layout row wrap>
                    <v-flex xs10 sm10 md12>
                        <span class=" subheading font-weight-medium"> {{ $t('Title_label') }} </span>
                    </v-flex>
                    <v-flex xs10 sm10 md12>
                        <span class="body-1" v-html="data.item.unvan1">
                        </span>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs10 sm10 md3>
                <v-layout row wrap>
                    <v-flex xs10 sm10 md12>
                        <span class="subheading font-weight-medium"> {{ $t("Title_label") }} 2</span>
                    </v-flex>
                    <v-flex xs10 sm10 md12>
                        <span class="body-1" v-html="data.item.unvan2">
                        </span>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </template>
</v-autocomplete>

<v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="900">
        <v-card>
            <v-card-title class="headline">{{$t("Search-Current")}}</v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 sm8 md6>
                        <v-text-field
                        v-model="limitSearchText"
                            :label="$t('Accound-Code')"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-text-field
                        v-model="Filters.TitleOne"
                            :label="$t('Title')" 
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-text-field
                        v-model="Filters.TitleTwo"
                            :label="$t('Title')" 
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-select hide-details v-model="Filters.AccountType" :items="musteritipi"
                                :label="$t('Customertype_label')" item-text="text" item-value="value">
                            </v-select>
                    </v-flex>
                     <v-flex xs12 md6 sm6>
                                                    <v-select :items="caritipi" hide-details="" v-model="Filters.AliciSatici" item-text="text" item-value="value" clearable :label="$t('Current-Type')">
                                                    </v-select>
                                                </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-text-field
                        v-model="Filters.TcNo"
                        :label="$t('IDNumber-or-TaxNumber')"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md12 pt-2>
                        <v-btn block color="primary" dark @click="cariGetirSearchDialog()"> {{ $t("Search") }}</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 md12 pt-2>
                  <v-flex xs12 sm12 md12>
                  <v-data-table
                    :headers="headers"
                    :items="dialogItems"
                    hide-actions
                    :loading="loadingResult"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <tr @click="setItem(props.item)">
                        <td class="text-xs-left">{{ props.item.id }}</td>
                        <td class="text-xs-left">{{ props.item.unvan1 }}</td>
                        <td class="text-xs-left">{{ props.item.unvan2 }}</td>
                        <td class="text-xs-left">{{ props.item.tckimlikno }}</td>
                        <td class="text-xs-left">{{ props.item.vergino }}</td>
                        <td class="text-xs-left">{{ props.item.uyari }}</td>
                        
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                    </v-flex>
                </v-layout>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="closeDialog()"> {{ $t("Close") }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-layout>
</div>

</template>

<script>
import auth from '../../../api/auth'

export default {
    props: {
        value: {
            type: String,
        },
        etiket: {
            type: String
        },
        Coper: {
            type: Boolean,
            default: false
        },
        FullSimple: {
            type: Boolean,
            default: false
        },
        engel:{
            default:false
        },
        statecariyedek: {
        },
        rules: {
            type: Boolean,
            default: false,
        },
        autofocuss: {
            type: Boolean,
            default: false,
        },
        renk: {
            type: String,
            default: 'blue-grey lighten-2'
        }
    },
    computed: {
        // eslint-disable-next-line vue/return-in-computed-property
        WatchStarter:function(){
            if(this.value != null && this.value != '' && this.value != 'undefined'){
                this.cariislemler()
            }
        },
        'Carihesap': {
            get: function () {
                return this.value
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        }
    },
    data() {
        return {
           caritipi: [{
                    text: this.$t('Customer-and-Supplier'),
                    value: 0
                },
                {
                    text: this.$t('Supplier'),
                    value: 1
                }, {
                    text: this.$t('Customer'),
                    value: 2
                },
            ],
            musteritipi: [{
                    text: this.$t('All'),
                    value: '0'
                }, {
                    text: this.$t('Individual'),
                    value: '1'
                }, {
                    text: this.$t('Corporate'),
                    value: '2'
                }],
            Filters: {
                    BaslangicCari: null,
                    BitisCari: null,
                    AnaHeseap: null,
                    HesapGrubu: [],
                    AnalizKodu: null,
                    Masraf: null,
                    CariTip: '0', //0:hepsi, 1 : bireysel, 2 : Kurumsal
                    HesapGrupBos: false,
                    MuhKodBos: false,
                    DisAktarimBos: false,
                    MasrafMerkeziTanimli: false,
                    TitleOne:null,
                    TitleTwo:null,
                    TcNo:null,
                    AliciSatici:0
            },
            loading: false,
            statecari: [],
            rule: [],
            searchcari: '',
            TempCariAra: "",
            searchLimit:false,
            headers:[
            {
                    text:this.$t('Code')
                },
                {
                    text:this.$t('Title1')
                },
                {
                    text:this.$t('Title2')
                },
                {
                    text:this.$t('IDNumber')
                },
                {
                    text:this.$t('TaxNumber')
                },
                {
                    text:this.$t('Warning')
                },
               
            ],
            dialogItems:[],
            loadingResult:false,
            limitSearchText:null,
            dialog:false,
        }
    },

    beforeMount: beforeMount,
    watch: {
        searchcari(val) {
        this.TempCariAra=val;   
        setTimeout(() => {
            if (this.TempCariAra===val)
            {
                val && this.carigetir(val);
            }
        },600);
        }
    },
    methods: {
        setItem(val){
        this.Carihesap = val.id;
        this.dialog = false;
        this.searchLimit = false;
        },
        closeDialog(){
         this.searchLimit = false;
        this.dialog = false;
        },
        openSearhDialog(){
         this.dialogItems = [];
         this.dialog  = true;
         this.searchLimit = true;
        },
        goDetailPage(){
         if(this.Carihesap){
            var url = "#/cari/goster/" + this.Carihesap
            window.open(url, '_target')
         }
        
        },
        selectCariComp() {
            document.getElementById("cariComp").select();
        },
        deleteCariComp() {
            this.Carihesap = null
            document.getElementById("cariComp").click();
        },
        focuslost(a) {
            if (a == null) {
                this.val = null
            }
        },
        cariislemler() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'))
            if(this.Carihesap.length <= 0){
                 return false;
            }
            var params = {}
            if (this.Coper == true) {
                params = {
                    Code: this.Carihesap,
                    CompanyCode: credentials.CoperSirketNo,
                    Coper: true
                }
            } else {
                params = {
                    Code: this.Carihesap,
                    CompanyCode: credentials.SirketKodu,
                    Coper: false
                }
            }

            this.$http.post(auth.API_URL + 'api/Current/Get', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                var yeniitems = {
                    id: response.body.Code,
                    unvan1: response.body.Title,
                    unvan2: response.body.Title2,
                    autoText: response.body.Title + "-" + response.body.Title2 + "-" + response.body.Code
                }

                this.statecari.push(yeniitems);
                this.$emit("sendCurrentData", response.body);

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = response.body.StatusText
                    this.snackbar = true
                }
            })
        },
        cariRemoteDoldur(v) {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'))


            var params = {}
            if (this.Coper == true) {
                params = {
                    Code: unescape(v),
                    CompanyCode: credentials.CoperSirketNo,
                    Coper: true
                }
            } else {
                params = {
                    Code: unescape(v),
                    CompanyCode: credentials.SirketKodu,
                    Coper: false
                }
            }

            this.$http.post(auth.API_URL + 'api/Current/Get', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                var yeniitems = {
                    id: response.body.Code,
                    unvan1: response.body.Title,
                    unvan2: response.body.Title2,
                    autoText: response.body.Title + "-" + response.body.Title2 + "-" + response.body.Code
                }

                return yeniitems;
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = response.body.StatusText
                    this.snackbar = true
                }
            })
        },
        carigetir: carigetir,
        cariGetirSearchDialog:cariGetirSearchDialog
    }
}



function beforeMount() {
    if (this.statecariyedek != 'undefined' && this.statecariyedek != null && this.statecariyedek != '') {
        //this.statecari.push(this.statecariyedek[0])
        this.cariislemler();
    } else if (this.value != null && this.value != '' && this.value != 'undefined') {
        this.cariislemler();
    }
    if (this.rules === true) {
        this.rule = [v => !!v || this.$t('Mandatory-section')]
    }
}

function carigetir(v) {
    this.statecari = []
    if (v.length >= 2) {
        setTimeout(() => {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'))

            var params = {}

            if (this.Coper == true) {
                params = {
                    q: unescape(v),
                    c: credentials.CoperSirketNo,
                    l: this.searchLimit,
                    Coper: true
                }
            } else {
                if (this.Coper == false) {
                    params = {
                        q: unescape(v),
                        c: credentials.SirketKodu,
                        l: this.searchLimit,
                        Coper: false
                    }
                } else {
                    params = {
                        q: unescape(v),
                        l: this.searchLimit,
                        c: credentials.SirketKodu,
                    }
                }

            }


            this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if(this.searchLimit == false){

                     for (var i = 0; i < response.body.length; i++) {
                    var yeniitems = {
                        id: response.body[i].id,
                        unvan1: response.body[i].unvan1,
                        unvan2: response.body[i].unvan2,
                        autoText: response.body[i].unvan1 + "-" + response.body[i].unvan2 + "-" + response.body[i].id + "-" + response.body[i].vergino + "-" + response.body[i].tckimlikno
                    }
                    this.statecari.push(yeniitems)
                }

                }else{
                    this.dialogItems = response.body;
                    this.loadingResult = false;
                }
               
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })
        }, 750)
    }
}


function cariGetirSearchDialog() {
    this.statecari = []
    if (this.searchLimit == true) {
        setTimeout(() => {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'))

            var params = {}

            if (this.Coper == true) {
                params = {
                    q: unescape(this.limitSearchText),
                    c: credentials.CoperSirketNo,
                    l: this.searchLimit,
                    Coper: true
                }
            } else {
                if (this.Coper == false) {
                    params = {
                        q: unescape(this.limitSearchText),
                        c: credentials.SirketKodu,
                        l: this.searchLimit,
                        Coper: false
                    }
                } else {
                    params = {
                        q: unescape(this.limitSearchText),
                        l: this.searchLimit,
                        c: credentials.SirketKodu,
                    }
                }

            }

            this.loadingResult = true;
            params = {
                ...params,
                Filters: this.Filters
            }

            this.$http.post(auth.API_URL + 'api/options/CurrentSearchForDialog', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if(this.searchLimit == false){

                     for (var i = 0; i < response.body.length; i++) {
                    var yeniitems = {
                        id: response.body[i].id,
                        unvan1: response.body[i].unvan1,
                        unvan2: response.body[i].unvan2,
                        autoText: response.body[i].unvan1 + "-" + response.body[i].unvan2 + "-" + response.body[i].id + "-" + response.body[i].vergino + "-" + response.body[i].tckimlikno
                    }
                    this.statecari.push(yeniitems)
                }

                }else{
                    this.dialogItems = response.body;
                    this.loadingResult = false;
                }
               
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })
        }, 750)
    }
}

</script>

<style scoped>
.carihesapsearch {
    max-height: 32;
    width: 95%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: justify;
    border-bottom: 1px solid rgb(118, 118, 118);
}

.teksatir {
    display: contents;
}
</style>
